
import { useState, useEffect } from 'react';
import { getEffectiveDate } from '@/lib/dateUtils';

export const CountdownTimer = () => {
  const [timeUntilNextGame, setTimeUntilNextGame] = useState<string>('');

  useEffect(() => {
    const updateCountdown = () => {
      // Build a virtual "now" based on the effective date's day with the real time-of-day
      const base = getEffectiveDate(); // debug-aware date at midnight
      const nowReal = new Date();
      const virtualNow = new Date(base);
      virtualNow.setHours(nowReal.getHours(), nowReal.getMinutes(), nowReal.getSeconds(), nowReal.getMilliseconds());

      const tomorrow = new Date(base);
      tomorrow.setDate(tomorrow.getDate() + 1); // next day at midnight

      const diff = tomorrow.getTime() - virtualNow.getTime();
      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      
      setTimeUntilNextGame(
        `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
      );
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="font-mono w-[80px] text-center">{timeUntilNextGame}</div>
  );
};
